import React from "react";
import { useNavigation } from "../../../hooks";
import Card from "../../ui/Card";
import Icon from "../../ui/Icon";

const MyDataManagementPage: React.FC = () => {
  const {
    navigateToSettings,
    navigateToInstitutionConnection,
    navigateToMyDataTermsList,
    navigateToConsentHistory,
    navigateToUsageHistory,
  } = useNavigation();

  const myDataItems = [
    {
      id: "institution-connection",
      title: "기관별 데이터 연결 관리",
      icon: "link",
      onClick: navigateToInstitutionConnection,
    },
    {
      id: "mydata-terms",
      title: "마이데이터 약관 및 이용동의",
      icon: "document",
      onClick: navigateToMyDataTermsList,
    },
    {
      id: "consent-history",
      title: "마이데이터 항목동의 내역",
      icon: "clipboard",
      onClick: navigateToConsentHistory,
    },
    {
      id: "usage-history",
      title: "마이데이터 이용내역",
      icon: "clock",
      onClick: navigateToUsageHistory,
    },
  ];

  return (
    <div className="h-screen-dvh bg-white flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center">
        <button
          onClick={navigateToSettings}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <Icon name="chevron-left" className="text-gray-600" />
        </button>      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 p-4">
        <div className="space-y-4">
          {myDataItems.map((item) => (
            <Card
              key={item.id}
              className="cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <button
                onClick={item.onClick}
                className="w-full text-left flex items-center space-x-4"
              >
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-gray-800">{item.title}</h3>
                </div>
                <div className="flex-shrink-0">
                  <Icon name="chevron-right" className="text-gray-400" />
                </div>
              </button>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default MyDataManagementPage;
